import CookieKeys from '../../const/CookieKeys';
import Cookies from 'js-cookie';

/**
 * システムの getters
 */
const getters = {
  showCustomizeRecommendSpots(state) {
    return state.customize.recommendSpotsParams && Object.keys(state.customize.recommendSpotsParams).length > 0;
  },
  userId(state) {
    return state.customize.userType === 'cognito' ? state.userId : Cookies.get(CookieKeys.PLANNING_COM_SEQ);
  },
  idToken(state) {
    return state.customize.userType === 'cognito' ? Cookies.get(CookieKeys.ID_TOKEN_COOKIE_KEY) : '';
  },
  topMenuHeight() {
    return 60;
  },
  bottomMenuHeight() {
    return 80;
  },
  siteTopURL: (state) => (isMobile, lang) => {
    if (state.customize.providesForNtj && state.customize.overseasSite && state.customize.overseasSite.siteTop &&
      state.customize.overseasSite.languages &&
      state.customize.overseasSite.languages.some(language => language.toLowerCase() === lang)) {
      // 海外向けサイト (Japan Travel) の場合
      return isMobile ? state.customize.overseasSite.siteTop.sp : state.customize.overseasSite.siteTop.pc;
    } else if (state.customize.siteTopURL) {
      // 国内向けサイト（トラベルパッケージ/NAVITIME Travel）の場合
      let target = isMobile ? state.customize.siteTopURL.sp : state.customize.siteTopURL.pc;
      if (state.customize.langList && state.customize.langList.length > 1) {
        // 多言語可の場合は言語のクエリパラメータを付与
        const url = new URL(target);
        url.searchParams.append('lang', lang);
        target = url.toString();
      }
      return target;
    } else {
      return '';
    }
  },
};

export { getters as default };
